import { Fragment, useRef } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Grid } from '@material-ui/core';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const testi = [
	{
		message: 'They really helped us during the pandemic with simplified loan disbursement and support in a short span of time.',
		name: 'Melvin Tom, Proprietor',
		desi: 'AVE M Engineering in Kerala',
		heading: 'Simplified loan disbursement'
	},
	{
		message: 'It was really important for me to file on time as I sell furniture to large hospitals who monitor my late gst payments. I like the GST PayLater facility because of the low interest rates and easy application process.',
		name: 'Davis',
		desi: 'Furniture Manufacturer in Chennai',
		heading: ' Low interest rates and easy application process'
	},
	{
		message: 'My customers delay payments due to which my tax payment is delayed every month. Thanks to the GST PayLater credit line, I have not missed any tax payment deadlines. Thankful to the ClearTax team and my CA who recommended this product to me.',
		name: 'Khalandar',
		desi: 'Construction Manufacturer in Bangalore',
		heading: 'I have not missed any tax payment deadlines'
	}
]

const Testimonial = () => {
	const slider = useRef(null)
	return (
		<div className="testimonialOutter">
			<div className="mainContent">
				<h2 className="headingMain">
					What are customers saying
					<div className="testimonialBtns">
						<button onClick={() => slider.current.prev()}>
							<ArrowBackIcon />
						</button>
						<button onClick={() => slider.current.next()}>
							<ArrowForwardIcon />
						</button>
					</div>
				</h2>
			</div>
			<div className="testimonialCon">
				<OwlCarousel ref={slider} autoplay className='owl-theme' dots={false} items={1} responsive={ {0: {stagePadding: 0}, 700: {stagePadding: 100} }} loop margin={10} >
			    {testi.map((item, index) => {
			    	return <div class='item' key={index}>
				      <div className="sliderItem">
				      	<Grid container spacing={3}>
				      		<Grid item md={8}>
						      	<h4>{item.heading}</h4>
						      	<p>{item.message}</p>
						      	<div className="userItem">
						      		<div className="userContent">
						      			<h5>{item.name}</h5>
						      			<p>{item.desi}</p>
						      		</div>
						      	</div>
						      </Grid>
						      <Grid item md={4}>
						      	<img className="sliderImage" src="testimonailCard.png" />
						      </Grid>
					      </Grid>
				      </div>
				    </div>
			    })}
				</OwlCarousel>
			</div>
		</div>
	)
}

export default Testimonial;